module.exports = __webpack_public_path__ + "img/fuse-top-spark-1_256x180.79919ce6.png";